import React from 'react';
import styled from 'styled-components';

import { getTermsUrl } from '@front/common/src/utils/terms-of-service';
import { ConfigRoutes, UniverseReference } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import SimpleLink from '@front/web-ui/src/components/link/simple-link';
import Text from '@front/web-ui/src/components/base-text/variants/text';

const t = translate('components.terms_of_service');

const TermsLabel = styled.div`
  margin: 0 0 20px;
`;

type TermsOfServiceProps = {
  routes?: ConfigRoutes;
  universe: UniverseReference;
};

const TermsOfService = ({ routes, universe }: TermsOfServiceProps) => (
  <TermsLabel>
    <Text.SM>{`${t('.signup.accept')} `}</Text.SM>
    <SimpleLink title={t('base.terms_of_service')} openInNewTab href={getTermsUrl(universe, routes)} size='sm'>
      {t('base.terms_of_service')}
    </SimpleLink>
    <>
      <Text.SM>{` ${t('.signup.and')} `}</Text.SM>
      <SimpleLink title={t('base.privacy_policy')} openInNewTab href={routes?.privacy_policy} size='sm'>
        {`${t('base.privacy_policy')}.`}
      </SimpleLink>
    </>
  </TermsLabel>
);

export default TermsOfService;
